import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import moment from 'moment'

import { tryToCreateTeamReactivateStripeCheckoutSession } from '../../actions/actions.export.js';

import Button from '../Button/Button.js'
import Tabs from '../Tabs/Tabs.js'

var pf_config = require('../../pf_config.json');

class TeamSettingsReactivateForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      pricing: 'yearly'
    }
  }


  render(){
    const { dispatch, team } = this.props; 
    const state = this.state;

    return (
      <div>
        <p>
          Your firm's subscription is no longer active and your team cannot currently leverage the paid features of Pattycake Firms.
        </p>
        <p>
          You can reactivate your subscription using our checkout portal via the button below.
        </p>
        <hr/>

        <div className="flex-center-column">
          <Tabs
            value={this.state.pricing}
            size="large"
            onChange={(e) => { 
              this.setState({pricing: e.value})
            }}
            items={[
                {
                  display: "Pay Monthly",
                  value: "monthly"
                },
                {
                  display: "Pay Yearly",
                  value: "yearly"
                },
              ]}
            />

          <div className="price-breakout small-margin-top">
            <span className="savings-line">{this.state.pricing === "monthly" ? <small>&nbsp;</small> : <small className="text-primary">2 months free!</small>}</span>
            <div className="price-breakout-number">
              <span className="dollar-sign">$</span>{this.state.pricing === "monthly" ? pf_config.plans.teams.price : pf_config.plans.teams.price_yearly}
              <span className="price-breakout-description"> / {this.state.pricing === "monthly" ? "month" : "year"}</span>
            </div>
            <div className="price-breakout-description">
              per 5 user license<br/>
            </div>
          </div>

          <Button
            display={"Checkout with Stripe"}
            onClick={e => dispatch(tryToCreateTeamReactivateStripeCheckoutSession({billing_mode: 'monthly', team_id: this.props.id}))}
            color="success"
            thinking={team.tryingToCreateTeamReactivateCheckoutSession}
            failed={team.failedToCreateTeamReactivateCheckoutSession}
            successful={team.successfullyCreatedTeamReactivateCheckoutSession}
            size="large"/>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  const { team } = state;

  return {
    team
  }
}

export default connect(mapStateToProps)(TeamSettingsReactivateForm);



// WEBPACK FOOTER //
// ./src/components/TeamSettingsReactivateForm/TeamSettingsReactivateForm.js